import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";

export type EllipsesMenuTableStockProps = {
  OnAddStock?: () => void;
  OnDeleteStock?: () => void;
};

const EllipsesMenuTableStock: React.FC<EllipsesMenuTableStockProps> = ({
  OnAddStock,
  OnDeleteStock,
}) => {
  return (
    <Menu as="div" className="relative flex-none">
      <MenuButton className="mt-1 block p-2 text-gray-500 hover:text-gray-900">
        <span className="sr-only">Open options</span>
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          aria-hidden="true"
          className="h-5 w-5"
        />
      </MenuButton>
      <MenuItems className="absolute right-0 z-50 mt-2 w-auto origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none">
        <MenuItem>
          <a
            onClick={OnAddStock}
            href="#"
            className="block px-3 py-1 text-sm leading-6 text-gray-500 hover:text-gray-900"
          >
            {t("store.views.add_stock")}
          </a>
        </MenuItem>
        <MenuItem>
          <a
            onClick={OnDeleteStock}
            href="#"
            className="block px-3 py-1 text-sm leading-6 text-gray-500 hover:text-gray-900"
          >
            {t("store.views.sub_stock")}
          </a>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};

export default EllipsesMenuTableStock;
